var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { twMerge } from "tailwind-merge";
import { ChampionTierScale } from "../../types/global";
function ChampionTier(_a) {
    var tier = _a.tier, size = _a.size, style = _a.style, showLabel = _a.showLabel, className = _a.className;
    function tierColor() {
        switch (tier) {
            case ChampionTierScale.S:
                return "text-primary ";
            case ChampionTierScale.A:
                return "text-action-900";
            case ChampionTierScale.B:
                return "text-info-900";
            case ChampionTierScale.C:
                return "text-success-900";
            case ChampionTierScale.D:
                return "text-neutral-400";
        }
    }
    return (_jsxs("div", __assign({ className: twMerge("flex flex-col items-center justify-center gap-1 text-center font-unbounded font-semibold", size === "small" ? "text-base" : "text-3xl", style === "bordered" && "rounded-full bg-neutral-600 px-[7px]", tierColor(), className) }, { children: [showLabel && _jsx("div", __assign({ className: twMerge("text-sm ", tierColor()) }, { children: "TIER" })), _jsx("span", __assign({ className: twMerge("flex items-center justify-center") }, { children: tier }))] })));
}
export default ChampionTier;
